<script setup lang="ts">
import IconFire from './IconFire.vue';
import IconFlood from './IconFlood.vue';
import IconHurricane from './IconHurricane.vue';
import IconTornado from './IconTornado.vue';

const props = defineProps<{
    name: string;
}>();
</script>

<template>
    <span class="me-2">
        <IconFire v-if="name == 'fire'" class="information-icon" />
        <IconFlood v-if="name == 'flood'" class="information-icon" />
        <IconHurricane v-if="name == 'hurricane'" class="information-icon" />
        <IconTornado v-if="name == 'tornado'" class="information-icon" />
    </span>
</template>

<style lang="scss" scoped>
.information-icon {
    height: 1em;
    width: 1em;
}
</style>
